var _defs, _rect, _polygon, _rect2, _rect3, _path, _path2, _line, _polygon2, _polygon3, _rect4, _rect5, _line2, _line3, _line4, _line5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpEnvelopeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:none;}.b,.c{fill:#3c3c46;opacity:0.15;}.b,.e,.g{fill-rule:evenodd;}.d,.e{fill:#ffefe0;}.d,.e,.f,.g,.h,.i{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.g,.h{fill:#fff;}.i{fill:#89d9fb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-envelope-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "25.19 103.88 25.19 62.99 64.29 44.19 103.39 62.99 103.39 103.88 25.19 103.88"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 45.17,
    y: 18,
    width: 75.63,
    height: 110
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 39.17,
    y: 12,
    width: 75.63,
    height: 110
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M114.81,122H39.17l2.47-6.17c1.26-3.15,2.77-5.34,6.17-5.34h58.36c3.39,0,4.9,2.2,6.17,5.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M114.81,12H39.17l4.12,13.33c.77,2.49,2.13,4.74,4.74,4.74h57.91c2.61,0,4-2.25,4.74-4.74Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 50.81,
    y1: 30.07,
    x2: 50.81,
    y2: 110.49
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "39.17 53.3 62.29 42.19 101.39 60.99 101.39 101.88 39.17 101.88 39.17 53.3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "19.2 56.99 58.29 38.19 97.39 56.99 97.39 97.88 19.2 97.88 19.2 56.99"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 19.2,
    y: 60.28,
    width: 78.19,
    height: 37.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 26.68,
    y: 67.73,
    width: 19.11,
    height: 10.24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 26.38,
    y1: 82.99,
    x2: 45.5,
    y2: 82.99
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 73.5,
    y1: 90.44,
    x2: 89.94,
    y2: 90.44
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 73.5,
    y1: 85.49,
    x2: 89.94,
    y2: 85.49
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 73.5,
    y1: 80.54,
    x2: 89.94,
    y2: 80.54
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpEnvelopeIcon);
export default __webpack_public_path__ + "static/media/CP-envelope-icon.6340a53d43cc5db5da53debc3cc2b9fb.svg";
export { ForwardRef as ReactComponent };